import { createContext, useContext, useMemo } from 'react';
import AutosaveAlertsContainer from '../components/AutosaveAlertsContainer';
import AutosaveIndicator from '../components/AutosaveIndicator';
import ManualSaveAlert from '../components/ManualSaveAlert';
import UnsavedChangesAlert from '../components/UnsavedChangesAlert';
import { useAutosaveCore } from '../hooks/useAutosaveCore';
import { useAutosaveEditingState } from '../hooks/useAutosaveEditingState';
import { useSavingMode } from '../hooks/useSavingMode';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AutosaveContext = /*#__PURE__*/createContext(undefined);
export const AutosaveProvider = ({
  children
}) => {
  const parentContext = useContext(AutosaveContext);
  const {
    data: savingMode,
    loading: savingModeLoading
  } = useSavingMode();
  const {
    getIsEditing,
    setIsEditing
  } = useAutosaveEditingState();
  const {
    cancelRequestsForSource,
    clearPendingRequests,
    enqueueRequest,
    getRegisteredFieldCount,
    hasRequestForSource,
    invalidRequests,
    lastSavedItems,
    saveValidRequests,
    registerHandler,
    requests,
    status,
    undo
  } = useAutosaveCore();
  const value = useMemo(() => {
    return {
      loading: savingModeLoading,
      mode: savingMode !== null && savingMode !== void 0 ? savingMode : 'auto',
      getIsEditing,
      setIsEditing,
      cancelRequestsForSource,
      enqueueRequest,
      getRegisteredFieldCount,
      hasRequestForSource,
      registerHandler,
      saveValidRequests
    };
  }, [savingModeLoading, savingMode, getIsEditing, setIsEditing, cancelRequestsForSource, enqueueRequest, getRegisteredFieldCount, hasRequestForSource, registerHandler, saveValidRequests]);
  if (parentContext !== undefined) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }
  return /*#__PURE__*/_jsxs(AutosaveContext.Provider, {
    value: value,
    children: [/*#__PURE__*/_jsxs(AutosaveAlertsContainer, {
      children: [savingMode === 'manual' ? /*#__PURE__*/_jsx(ManualSaveAlert, {
        invalidRequests: invalidRequests,
        onSave: saveValidRequests,
        onCancel: clearPendingRequests,
        requests: requests
      }) : /*#__PURE__*/_jsx(UnsavedChangesAlert, {
        requests: requests
      }), /*#__PURE__*/_jsx(AutosaveIndicator, {
        status: status,
        onUndo: undo,
        items: lastSavedItems
      })]
    }), children]
  });
};
export const useAutosaveContext = () => {
  const context = useContext(AutosaveContext);
  if (context === undefined) {
    throw new Error('useAutosaveContext must be used within AutosaveProvider');
  }
  return context;
};